/*
 *ajax
 */

//引入
import request from "../utils/request";

export function tzdH5(params) {
    return request({
        method: 'get',
        url: '/prod-api/deposit/api/wxzjjctzd/tzdH5',
        params,
    })
}

// 浏览次数
export function voucherInfo(params) {
    return request({
        method: 'get',
        url: '/prod-api/deposit/api/wxzjjctzd/voucherInfo',
        params,
    })
}

// 中行
// export function crateOrderId(id) {
//     return request({
//         method: 'post',
//         url: '/prod-api/order/api/wxzjtzdorder/crateOrder/' + id,
//     })
// }
// 农行
export function crateOrderId(id) {
    return request({
        method: 'get',
        url: '/prod-api/order/api/wxzjqworder/createOrder/' + id,
    })
}

// http://192.168.2.96:8990/deposit/api/wxzjjctzd/sendemail?email=1204972123@qq.com&tzdId=123
export function sendemail(params) {
    return request({
        method: 'get',
        url: '/prod-api/deposit/api/wxzjjctzd/sendemail',
        params
    })
}